<div #controlInput class="input-container">
  <div *ngIf="showLabel">
    <span>{{ label | translate }}</span>
    <span *ngIf="showAsterisk && isRequired">*</span>
  </div>
  <ng-container [ngSwitch]="controlType">
    <input
      *ngSwitchCase="'text'"
      appInputControl
      [inputControlRegex]="controlRegex"
      [type]="controlType"
      [id]="label"
      [placeholder]="placeholder | translate"
      [formControl]="control"
      [minlength]="minlength" />

    <input
      *ngSwitchCase="'number'"
      appInputControl
      [inputControlRegex]="validationPatterns"
      [type]="controlType"
      [id]="label"
      [placeholder]="placeholder | translate"
      [formControl]="control"
      [minlength]="minlength"
      [min]="minValue" />

    <input
      *ngSwitchCase="'mask'"
      appInputControl
      [inputControlRegex]="controlRegex"
      [prefix]="prefix"
      [mask]="mask"
      [showMaskTyped]="true"
      [dropSpecialCharacters]="false"
      [type]="controlType"
      [id]="label"
      [placeholder]="placeholder | translate"
      [formControl]="control" />

    <input
      *ngSwitchCase="'currency'"
      prefix="$ "
      mask="separator.2"
      thousandSeparator=","
      appInputControl
      [type]="controlType"
      [id]="label"
      [placeholder]="placeholder | translate"
      [formControl]="control" />

    <textarea
      *ngSwitchCase="'textarea'"
      appInputControl
      [inputControlRegex]="controlRegex"
      [id]="label"
      [cols]="cols"
      [rows]="rows"
      [placeholder]="placeholder | translate"
      [formControl]="control">
    </textarea>

    <input
      *ngSwitchDefault
      appInputControl
      [inputControlRegex]="controlRegex"
      [type]="controlType"
      [id]="label"
      [placeholder]="placeholder | translate"
      [formControl]="control" />
  </ng-container>
  <!-- <div *ngIf="control.errors && control.touched && isTouched" class="error-container">
    <ng-container *ngIf="getError() as error">
      <span *ngIf="error === 'errors.required'">{{ label | translate }}</span>
      <span>{{ error | translate }}</span>
    </ng-container>
  </div> -->
</div>
